var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"bgSt"}},[_c('s-header'),_c('v-card',{staticClass:"overflow-hidden",attrs:{"id":"navNcon"}},[_c('s-navigation'),_c('s-content',{staticClass:"pd-0"})],1),_c('s-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }